var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTranslationFinished = function SvgTranslationFinished(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#51C394"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.856 6.855a.643.643 0 0 0-.643.643v7.715c0 1.42 1.15 2.57 2.57 2.571h6.43c.98 0 1.656-.423 2.064-.99a2.796 2.796 0 0 0 .507-1.581.643.643 0 0 0-.642-.643h-1.93V7.498a.643.643 0 0 0-.642-.643H6.856Zm3.857 7.715h3.214V8.14H7.5v7.072c0 .71.575 1.285 1.285 1.285h.002c.218 0 .56-.07.828-.264.236-.17.456-.46.456-1.021 0-.355.288-.643.643-.643Zm.34 1.928h4.16c.562 0 .85-.22 1.021-.456.043-.06.08-.122.111-.187h-5.056a2.448 2.448 0 0 1-.236.643ZM8.784 10.07c0-.355.288-.643.643-.643H12a.643.643 0 0 1 0 1.286H9.427a.643.643 0 0 1-.643-.643Zm.643 1.285a.643.643 0 1 0 0 1.286H12a.643.643 0 0 0 0-1.286H9.427Z",
    clipRule: "evenodd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#51C394"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.066 16.9a4.9 4.9 0 1 1 0-9.8 4.9 4.9 0 0 1 0 9.8Zm-6.3-4.9a6.3 6.3 0 1 1 12.6 0 6.3 6.3 0 0 1-12.6 0Zm9.338-.898a.7.7 0 0 0-.976-1.004l-3.105 3.02-1.262-1.263a.7.7 0 0 0-.99.99l1.75 1.75a.7.7 0 0 0 .983.007l3.6-3.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgTranslationFinished;